import { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { FaPhone, FaMapMarkerAlt, FaCheckCircle, FaPaperPlane } from 'react-icons/fa';
import { contactService } from '../../../services/contact.services';
import { colors } from '../../../utils/Colors';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await contactService.createContact(formData);
            console.log(response)
            if (response.success) {
                setSuccess(response.message);
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                });


                setTimeout(() => {
                    setSuccess(false);
                }, 3000);
            } else {
                setError(response.data.message || 'Failed to send message');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-page py-5" style={{ backgroundColor: '#f8f9fa' }}>
            <Container>

                <div className="text-center mb-5">
                    <h1 className="display-5 fw-bold mb-3" style={{ color: colors.PRIMARY }}>
                        Contact Us
                    </h1>
                    <p className="lead text-muted mb-4">
                        Get in touch with RONAQ Banquet for bookings and inquiries
                    </p>
                </div>

                <Row className="g-4">

                    <Col lg={4}>
                        <Card className="h-100 border-0 shadow-sm mb-4">
                            <Card.Body className="p-4">
                                <div className="text-center mb-4">
                                    <div className="contact-icon-circle mb-3" style={{
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '50%',
                                        backgroundColor: colors.PRIMARY,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto'
                                    }}>
                                        <FaPhone size={30} color="white" />
                                    </div>
                                    <h4 className="fw-bold">Phone Numbers</h4>
                                </div>

                                <div className="contact-info-item mb-3">
                                    <div className="d-flex align-items-center mb-2">
                                        <FaPhone className="me-3" style={{ color: colors.SECONDARY }} />
                                        <strong>Manager:</strong>
                                    </div>
                                    <p className="ms-4 mb-0">0315-5530667</p>
                                </div>

                                <div className="contact-info-item mb-3">
                                    <div className="d-flex align-items-center mb-2">
                                        <FaPhone className="me-3" style={{ color: colors.SECONDARY }} />
                                        <strong>Support:</strong>
                                    </div>
                                    <p className="ms-4 mb-0">0332-9911223</p>
                                </div>

                                <div className="contact-info-item">
                                    <div className="d-flex align-items-center mb-2">
                                        <FaPhone className="me-3" style={{ color: colors.SECONDARY }} />
                                        <strong>Office:</strong>
                                    </div>
                                    <p className="ms-4 mb-0">0332-5412237</p>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>


                    <Col lg={8}>
                        <Card className="border-0 shadow-lg">
                            <Card.Body className="p-4">
                                <div className="text-center mb-4">
                                    <h3 className="fw-bold" style={{ color: colors.PRIMARY }}>
                                        Send Us a Message
                                    </h3>
                                    <p className="text-muted">
                                        Fill out the form below and we'll get back to you within 24 hours
                                    </p>
                                </div>


                                {success && (
                                    <Alert variant="success" className="d-flex align-items-center">
                                        <FaCheckCircle className="me-2" />
                                        Your message has been sent successfully! We'll contact you soon.
                                    </Alert>
                                )}

                                {error && (
                                    <Alert variant="danger">
                                        {error}
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                        <Col md={6} className="mb-3">
                                            <Form.Group>
                                                <Form.Label className="fw-bold">
                                                    Full Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    placeholder="Enter your full name"
                                                    required
                                                    disabled={loading}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6} className="mb-3">
                                            <Form.Group>
                                                <Form.Label className="fw-bold">
                                                    Email Address <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    placeholder="Enter your email"
                                                    required
                                                    disabled={loading}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={6} className="mb-3">
                                            <Form.Group>
                                                <Form.Label className="fw-bold">
                                                    Phone Number <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="tel"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    placeholder="03XX-XXXXXXX"
                                                    required
                                                    disabled={loading}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6} className="mb-3">
                                            <Form.Group>
                                                <Form.Label className="fw-bold">
                                                    Subject
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value="Inquiry/Booking"
                                                    disabled
                                                    readOnly
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group className="mb-4">
                                        <Form.Label className="fw-bold">
                                            Message <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            placeholder="Please describe your requirements..."
                                            required
                                            disabled={loading}
                                        />
                                    </Form.Group>

                                    <div className="text-center">
                                        <Button
                                            variant="warning"
                                            type="submit"
                                            size="lg"
                                            className="px-5 py-2 fw-bold"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Sending...
                                                </>
                                            ) : (
                                                <>
                                                    <FaPaperPlane className="me-2" />
                                                    Send Message
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>


                        <Card className="border-0 shadow-sm mt-4">
                            <Card.Body className="p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="me-3">
                                        <FaMapMarkerAlt size={30} style={{ color: colors.PRIMARY }} />
                                    </div>
                                    <div>
                                        <h4 className="fw-bold mb-1">Our Location</h4>
                                        <p className="mb-0 text-muted">Main NUST Double Road, OPP. Gate # H13, Islamabad, Pakistan</p>
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <iframe
                                        title="RONAQ Banquet Location"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3322.844164476908!2d72.9834075!3d33.6396545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df97006fecda1f%3A0xd1b3c85fcbf7aad0!2sRonaq%20Banquets!5e0!3m2!1sen!2s!4v1700000000000"
                                        width="100%"
                                        height="250"
                                        style={{ border: 0, borderRadius: '10px' }}
                                        allowFullScreen
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    ></iframe>
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


            </Container>

            <style jsx="true">{`
                .contact-page {
                    min-height: 100vh;
                }
                
                .contact-icon-circle {
                    transition: all 0.3s ease;
                }
                
                .contact-icon-circle:hover {
                    transform: scale(1.1);
                }
                
                .opening-hours {
                    background-color: #f8f9fa;
                    padding: 20px;
                    border-radius: 10px;
                }
                
                .contact-quick-icon {
                    transition: all 0.3s ease;
                }
                
                .contact-quick-icon:hover {
                    transform: translateY(-5px);
                }
                
                .card {
                    transition: all 0.3s ease;
                    border-radius: 15px;
                }
                
                .card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
                }
                
                @media (max-width: 768px) {
                    .display-5 {
                        font-size: 2.2rem;
                    }
                    
                    .lead {
                        font-size: 1.1rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default ContactUs;